/** @jsx jsx */
import { Fragment, useEffect } from 'react'
import { jsx } from 'theme-ui'

const KlaviyoOnsiteScript = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = '//static.klaviyo.com/onsite/js/NvDa6e/klaviyo.js'
    script.async = true
    document.getElementsByTagName('head')[0].appendChild(script)
  }, [])

  return <Fragment />
}

export default KlaviyoOnsiteScript
